import { getTeams, patchTeam, createTeam } from '@fno/service/api/teams.js'
import { getArenas } from '@fno/service/api/arenas.js'
import { preFormMutator, preSaveMutator, getKeypath, preChangeMutator, nextHandler, previousHandler } from '@fno/route/hello/task/helpers.js'
import genericChange from '@fno/lib/form/generic-change.js'
import genericReset from '@fno/lib/form/generic-reset.js'
import genericSave from '@fno/lib/form/generic-save.js'
import teamSchema from 'fanx-schema/resource/team'
import arenaSchema from 'fanx-schema/resource/arena'
import template from './Teams.svelte'
import transformApiResponseToFormObject from '@fno/lib/transform-api-response-to-form-object.js'
import setContextOriginal from '@fno/lib/form/set-context-original.js'

const page = {
    teams: {
        type: Array,
        schema: teamSchema,
        patch: team => patchTeam({ team }),
        post: team => createTeam({ team })
    }
}

export default (parent, stateRouter) => {
    const name = `${parent}.teams`

    stateRouter.addState({
        name,
        route: '/teams',
        template,
        data: {
            title: 'Teams | T.A.B.'
        },
        resolve: async (ignore, { schoolId }) => {
            const [ teams, arenas ] = await Promise.all([
                getTeams({ schoolId }),
                getArenas({ schoolId })
            ])

            return setContextOriginal({
                context: {
                    form: {
                        teams: teams.map(team => transformApiResponseToFormObject({ schema: teamSchema, data: team }))
                    },
                    view: {
                        arenas: arenas.map(arena => transformApiResponseToFormObject({ schema: arenaSchema, data: arena })),
                        schoolId
                    }
                }
            }, preFormMutator)
        },
        activate: ({ domApi: component, parameters: { schoolId } }) => {
            const save = genericSave({ component, page, preSaveMutator, preFormMutator })
            component.$on('nextStepClicked', nextHandler({
                stateRouter,
                component,
                save,
                schoolId,
                stepId: 'TEAMS',
                nextId: 'features'
            }))
            component.$on('previousStepClicked', previousHandler(stateRouter, 'venues', schoolId))
            component.$on('save', save)
            component.$on('change', genericChange({ component, page, getKeypath, preChangeMutator }))
            component.$on('reset', genericReset({ component }))
        }
    })
}
